import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import * as auth from "../../store/ducks/auth.duck";
import { forgotPasswordCode } from "../../crud/auth.crud";
import { useHistory } from "react-router-dom";
import PinInput from "react-pin-input";
import queryString from "query-string";
import SwAlert from "../../components/SwAlert";
import { createFormikValidation } from "../../utils/Utils";
import { CircularProgress, IconButton, useMediaQuery } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const CodigoSenha = (props) => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const { email } = queryString.parse(props.location.search, { decode: false });
    const isMobileScreen = useMediaQuery("(max-width: 576px)");

    const onSubmit = (values) => {
        setLoading(true);

        forgotPasswordCode({ email, code: values.pin })
            .then((res) => {
                history.push(`/alterar-senha?email=${email}&token=${res.data.token}`);
            })
            .catch((err) => {
                setLoading(false);

                SwAlert({
                    title: err?.response?.data?.errors?.[0] ?? `Parece que houve um problema`,
                    text: err?.response?.data?.errors ? null : "Por favor, entre em contato com o suporte.",
                    customClass: {
                        content: err?.response?.data?.errors ? "p-0 pb-32" : "",
                    },
                    confirmButtonText: "Fechar",
                    icon: "error",
                });
            });
    };

    const getInitialValues = () => {
        return {
            pin: "",
        };
    };

    const validate = (values) => {
        const map = new Map();

        map.set("pin", "PIN");

        return createFormikValidation(map, values);
    };

    return (
        <div class="authContainerContainer">
            <div className="esqueceuSenhaContainer">
                <div>
                    <IconButton onClick={() => history.push("/login")} className="p-0">
                        <div className="d-flex gap-8 align-items-center color-dark-6">
                            <ArrowBackIosIcon style={{ color: "#9CA3AF", fontSize: 14 }} />

                            <span className={`tt-16 medium`}>Voltar</span>
                        </div>
                    </IconButton>
                </div>

                <div className="d-flex flex-column gap-12">
                    <span className={`tt-24 semibold color-white`}>Insira o código</span>

                    <span className={`tt-16 color-dark-6`}>
                        Insira o código enviado para o e-mail <span className="color-main-dark-5 tt-underline">{email}</span>.
                    </span>
                </div>

                <Formik initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
                    {({ setFieldValue, handleSubmit }) => (
                        <form noValidate autoComplete="off" onSubmit={handleSubmit} className="d-flex flex-column gap-40">
                            <div className="d-flex flex-column gap-24">
                                <PinInput
                                    length={5}
                                    focus
                                    type="numeric"
                                    onChange={(v) => setFieldValue("pin", v)}
                                    onComplete={(v) => setFieldValue("pin", v)}
                                    placeholder="0"
                                    inputStyle={{
                                        fontSize: isMobileScreen ? 18 : 24,
                                        height: "100%",
                                        textAlign: "center",
                                        border: "1px solid #374151",
                                        borderRadius: 8,
                                        backgroundColor: "transparent",
                                        color: "#FFF",
                                        fontWeight: "500",
                                        lineHeight: isMobileScreen ? 24 : 36,
                                        flex: 1,
                                        margin: 0,
                                    }}
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        flexDirection: "row",
                                        overflow: "auto",
                                        gap: 8,
                                        height: 88,
                                    }}
                                />
                            </div>

                            <button type="submit" disabled={loading} className="btn btn-primary btn-large tt-16 medium">
                                {loading ? <CircularProgress size={14} className="margin-icon" style={{ color: "#fff" }} /> : ""}Recuperar senha
                            </button>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default connect(null, auth.actions)(CodigoSenha);
